const WeightTypes = [
    {key: "kg", text: "kg", value: 1},
    {key: "gr", text: "gr", value: 1000},
    {key: "mg", text: "mg", value: 1000000}
];

export default WeightTypes;